import React from 'react';
import { ClipboardCheckIcon, BookOpenIcon, ShieldCheckIcon, WifiIcon, KeyRoundIcon, SmartphoneIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function IntroAssessmentPage() {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-1934">
      {/* Header with logo */}
      <header className="w-full bg-white border-b border-gray-100 px-5 py-3" data-id="element-1935">
        <div className="max-w-md mx-auto flex items-center justify-center" data-id="element-1936">
          <Link to="/" className="flex-shrink-0" data-id="element-1937">
            <img src="https://cdn.magicpatterns.com/uploads/8EVxVy8dkAVEdmFcPkswyr/Caveo_2026_Logo.png" alt="Caveo" className="h-6" data-id="element-1938" />
          </Link>
        </div>
      </header>

      {/* Main content */}
      <div className="px-5 pt-4 pb-6 flex-1 flex flex-col" data-id="element-1939">
        <div className="max-w-md mx-auto flex flex-col items-center text-center flex-1" data-id="element-1940">
          {/* Heading */}
          <h1 className="text-[1.75rem] md:text-[2.25rem] font-semibold text-[#111111] leading-[1.15] tracking-tight mb-1" data-id="element-1941">
            Digital Safety Check
          </h1>
          <p className="text-sm md:text-base text-gray-500 leading-relaxed mb-4" data-id="element-1942">
            Get a personalized action plan in 3-4 minutes.
          </p>

          {/* Three-step process */}
          <div className="flex items-center justify-center mb-5" data-id="element-1943">
            <div className="flex flex-col items-center" data-id="element-1944">
              <div className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1945">
                <ClipboardCheckIcon size={18} className="text-gray-400" data-id="element-1946" />
              </div>
              <span className="mt-1.5 text-xs font-semibold text-[#111111]" data-id="element-1947">
                Assess
              </span>
            </div>

            <div className="w-8 md:w-12 h-[2px] bg-gray-200 mb-4" data-id="element-1948" />

            <div className="flex flex-col items-center" data-id="element-1949">
              <div className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1950">
                <BookOpenIcon size={18} className="text-gray-400" data-id="element-1951" />
              </div>
              <span className="mt-1.5 text-xs font-semibold text-[#111111]" data-id="element-1952">
                Plan
              </span>
            </div>

            <div className="w-8 md:w-12 h-[2px] bg-gray-200 mb-4" data-id="element-1953" />

            <div className="flex flex-col items-center" data-id="element-1954">
              <div className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1955">
                <ShieldCheckIcon size={18} className="text-gray-400" data-id="element-1956" />
              </div>
              <span className="mt-1.5 text-xs font-semibold text-[#111111]" data-id="element-1957">
                Act
              </span>
            </div>
          </div>

          {/* What we'll cover label */}
          <p className="text-[#631bb7] text-sm mb-3 font-medium" data-id="element-1958">
            Here's what we'll cover:
          </p>

          {/* What's Covered */}
          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-1959">
            <div className="flex px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm items-center justify-center" data-id="element-1960">
              <span className="text-lg flex-shrink-0" data-id="element-1961">🏠</span>
              <span className="ml-1.5 text-xs text-[#111111] whitespace-nowrap font-medium" data-id="element-1962">
                Home Network
              </span>
            </div>
            <div className="flex items-center px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-1963">
              <span className="text-lg flex-shrink-0" data-id="element-1964">🔐</span>
              <span className="ml-1.5 text-xs text-[#111111] whitespace-nowrap font-medium" data-id="element-1965">
                Passwords
              </span>
            </div>
            <div className="flex items-center px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-1966">
              <span className="text-lg flex-shrink-0" data-id="element-1967">📱</span>
              <span className="ml-1.5 text-[#111111] whitespace-nowrap text-xs font-medium" data-id="element-1968">
                Devices
              </span>
            </div>
            <div className="flex items-center px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-1969">
              <span className="text-lg flex-shrink-0" data-id="element-1970">🛡️</span>
              <span className="ml-1.5 text-xs text-[#111111] whitespace-nowrap font-medium" data-id="element-1971">
                Data & Privacy
              </span>
            </div>
          </div>

          <div className="mt-auto w-full pt-4" data-id="element-1972">
            {/* Start Assessment button */}
            <Link to="/assessment" className="block w-full bg-[#631bb7] text-white px-6 py-3.5 rounded-xl font-medium text-base no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-1973">
              Start Assessment
            </Link>
          </div>
        </div>
      </div>
    </div>;
}